import { Address } from '@/models/common/address';
import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

export enum BusinessAddressType {
    FrontPageContactAddress,
    PickupAddress,
}

export class BusinessAddress extends Address {
    public id: number = 0;
    public businessId: number = 0;
    public type?: BusinessAddressType;

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Businesses;
    }

    public get permissionsIdToCheck(): number {
        return this.businessId;
    }

    constructor(json?: any) {
        super(json);

        if (!json) {
            return;
        }

        this.id = json.id;
        this.businessId = json.businessId;
        this.type = json.type;
    }

    public clone(): BusinessAddress {
        const address: BusinessAddress = new BusinessAddress();

        address.id = this.id;
        address.businessId = this.businessId;
        address.type = this.type;
        address.street = this.street;
        address.number = this.number;
        address.details = this.details;
        address.postalCode = this.postalCode;
        address.city = this.city;
        address.stateId = this.stateId;
        address.stateName = this.stateName;
        address.countryId = this.countryId;
        address.countryName = this.countryName;

        return address;
    }
}
